<!-- pickcity选择框 -->
<template>
  <div class="form_city_wrap text_a_left bd_c_f margin_b_10">
    <div
      class="form_item_name"
      :class="option.isRequire ? 'form_item_isNeed' : ''"
      v-if="layout === 'vertical'"
    >
      {{ option.label }}
    </div>
    <div
      v-if="option.hasDescription && layout === 'vertical'"
      class="form_item_desc"
    >
      {{ option.description }}
    </div>
    <van-cell-group>
      <van-field
        :label="layout === 'horizontal' ? option.label : null "
        :class="layout === 'horizontal' ? (option.isRequire ? 'form_item_horizontal_isNeed' : '') : '' "
        v-model="option.value"
        is-link
        readonly
        :placeholder="option.placeholder"
        @click="handlePick"
        :name="option.name"
        :error-message="errorMessage"
        :rules="[
          {
            validator: asyncValidator,
            message: $t('book.validator.require')
          }
        ]"
      />
    </van-cell-group>
    <!-- 弹框 -->
    <van-popup
      v-model="show"
      :get-container="getContainer"
      position="bottom"
    >
      <van-area
        class="form_city_picker_wrap"
        @confirm="handleConfirm"
        @cancel="handleCancel"
        :loading="loading"
        :area-list="areaList"
        :columns-num="dataSty"
        :value="pickedCode"
      />
    </van-popup>
  </div>
</template>

<script>
import cityList from '@/mock/city'
import { GetAreaCode } from '@a/js/api/public'
export default {
  name: 'FormCity',
  props: {
    option: {
      type: Object,
      default: () => ({})
    },
    layout: {
      type: String,
      default: "horizontal" // horizontal 水平 vertical 垂直
    }
  },
  data() {
    return {
      pickedCode: '',
      show: false,
      loading: false,
      areaList: cityList,
      // areaObj: {},
      dataSty: 0,
      error: false,
      errorMessage: ''
    }
  },

  components: {},

  watch: {
    option: {
      handler(data) {
        // 获取格式 
        let tempStr = data.dataStyle
        if (tempStr === '省市区') {
          this.dataSty = 3
        } else if (tempStr === '省市') {
          this.dataSty = 2
        } else if (tempStr === '省') {
          this.dataSty = 1
        }
        // 获取初始值
        if (data.value.length > 0) {
          // 获取区域编码
          let resdata = {
            value: data.value
          }
          GetAreaCode(resdata)
            .then(res => {
              // console.log(res)
              let tempArr = []
              Object.keys(res.data).map(key => {
                tempArr.push(String(res.data[key]))
              })
              this.pickedCode = tempArr[tempArr.length - 1]
            })
            .catch(() => { })
        } else {
          this.pickedCode = ''
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    //格式校验方法
    asyncValidator(value) {
      return new Promise(resolve => {
        if (value.length > 0) {
          resolve(this.SetCheckSuccMsg())
        } else {
          if (this.option.isRequire) {
            resolve(this.SetCheckErrorMsg(this.$t('book.validator.require')))
          } else {
            resolve(this.SetCheckSuccMsg())
          }
        }
      })
    },
    // 设置校验不通过提示内容
    SetCheckErrorMsg(msg) {
      this.error = true
      this.errorMessage = msg
      return false
    },
    // 设置校验通过提示内容
    SetCheckSuccMsg() {
      this.error = false
      this.errorMessage = ''
      return true
    },

    // 设置popup挂载点
    getContainer() {
      return document.querySelector('.form_city_wrap')
    },
    // 开始选择
    handlePick() {
      this.show = true
    },
    // 确认选择
    handleConfirm(value) {
      console.log(value)
      this.getAreaText(value).then(res => {
        // console.log(res)
        this.$emit('listenAreaMsgChanged', this.option.name, res)
        this.asyncValidator(this.option.value)
      })
      this.pickedCode = value[value.length - 1].code
      // console.log(this.pickedCode)
      this.show = false
    },
    // 取消选择
    handleCancel() {
      this.show = false
    },
    // 获取当前选中区域的汉字信息
    getAreaText(arr) {
      return new Promise(resolve => {
        let tempText = ''
        arr.map(item => {
          tempText += item.name + '/'
        })
        resolve(tempText.substr(0, tempText.length - 1))
      })
    },
    // 通过区域文字获取区域编码
    GetAreaCodeByText(text) {
      let textArr = text.split('/')
      let lastText = textArr[textArr.length - 1]
      this.pickedCode = this.areaObj[lastText]
      console.log(this.areaObj[lastText])
    }
  },

  mounted() { }
}
</script>
<style lang="less" scoped>
.form_city_picker_wrap {
  touch-action: none;
}
</style>
